import { Layout } from './components';

export const OrderStatus = {
  Layout,
};
